export default "__VITE_ASSET__BLmXk63o__"